import React from 'react';

import styled from '@emotion/styled';

import SummaryCard from '../../../components/Summary/SummaryCard';
import { SummaryData } from './SummaryData';

const Summary = () => {
  return (
    <Container>
      <Text>Summary</Text>
      <IconArea>
        {SummaryData.map((item, index) => (
          <SummaryCard
            key={index}
            imgName={item.imgName}
            stats={item.label === 'Withheld' ? 30 : 20}
            label={item.label}
          />
        ))}
      </IconArea>
    </Container>
  );
};

export default Summary;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const IconArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  border: 1px solid ${({ theme }) => theme.palette.borderLineColor};
  border-radius: 1rem;
  padding: 2rem;
  background: white;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.palette.secondaryText};
  font-weight: 700;
  font-size: 1.25rem;
`;
